/* eslint-disable react/no-unescaped-entities */
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useT } from "@/lib/i18n";

export default function Faq() {
  const t = useT();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#FAFAF7]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <div className="text-sm font-bold uppercase tracking-[0.2em] text-[#E05A3D]">
            {t.faq.overline}
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tight text-[#1C3A27]">
            {t.faq.headline}
          </h2>
          <p className="mt-5 text-lg text-[#5C6B5C]">
            {t.faq.hint_a}{" "}
            <a
              href="#contact"
              className="underline underline-offset-4 decoration-[#E05A3D] hover:text-[#1C3A27]"
            >
              {t.faq.hint_link}
            </a>
            .
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          data-testid="faq-accordion"
          className="mt-14 space-y-3"
        >
          {t.faq.items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-[#E2E4DF] rounded-2xl bg-white px-6 data-[state=open]:border-[#1C3A27] data-[state=open]:shadow-sm transition-all"
            >
              <AccordionTrigger className="text-start font-display font-semibold text-lg md:text-xl text-[#1C3A27] py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5C6B5C] text-base leading-relaxed pb-6 pe-4">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
